module.exports = __webpack_public_path__ + "img/wyty.fb7eb3b.png";